import { twMerge } from 'tailwind-merge';
import type { DecoratedOrderTask } from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import { formatOrderName } from '@witmetrics/utils/orders';
import { useAppState } from '@/providers/AppStateProvider';
import ProfilePicture from '@/components/ProfilePicture';
import Tooltip from '@/components/Tooltip';
import UserChip from '@/components/UserChip';
import DueDate from './DueDate';
import { classes } from './utils';

export type OrderTaskHeaderProps = {
  condensed?: boolean;
  onlyTime?: boolean;
  orderTask: DecoratedOrderTask;
};

export default function OrderTaskHeader({
  condensed,
  onlyTime,
  orderTask: { task, order },
}: OrderTaskHeaderProps) {
  const { onSelectOrder } = useAppState();

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftContent}>
        <button
          className={twMerge(classes.name, task.isResolved && classes.resolved)}
          onClick={() => onSelectOrder(order.id)}>
          {formatOrderName(order)}
        </button>
        <DueDate onlyTime={onlyTime} task={task} />
      </div>
      <div className={classes.rightContent}>
        {condensed ? (
          <Tooltip title={formatUserName(task.assignedTo)}>
            <div>
              <ProfilePicture
                className={classes.profilePicture}
                size={25}
                user={task.assignedTo}
              />
            </div>
          </Tooltip>
        ) : (
          <UserChip user={task.assignedTo} />
        )}
      </div>
    </div>
  );
}
